import React from 'react';
import { Flex, Row } from 'antd';
import { TikTokOutlined, WechatOutlined, AlipayOutlined } from '@ant-design/icons';
import { detectScreen } from '../../utils/device';

const screen = detectScreen();

const OauthLinkMap = {
    wxopen_mini: `/wxopen/oauth?type=wxopen_mini&pageType=${screen}`,
    wxopen_service: `/wxopen/oauth?type=wxopen_service&pageType=${screen}`,
    alipay: '',
    douyin: '',
}

// <TikTokOutlined /> <WechatOutlined /> <AlipayOutlined />
const style = {padding: '10px', width: '50px', margin: 'auto', width: '50px', height: '50px', border: '1px solid #cccccc', borderRadius: '10px', fontSize: '28px' };
const ChannelCard = ({ icon = null, name='', title = 'title', description = 'description', list = [] }) => {

    const hasOauth = list.find((item) => item.name === name);

    return (
        <Flex justify='flex-start' gap={10} style={{border: '1px solid #dfdfdf', padding: '10px', borderRadius: '3px', width: '100%', minWidth: '260px', maxWidth: '390px'}}>
            <div style={style}>{icon}</div>
            <Flex vertical={true} gap={6}>
                <div style={{fontSize: '16px', fontWeight: 'bold'}}>{title}</div>
                <div>{description}</div>
            </Flex>
            {
                hasOauth ? <a href={`/channel/oauth/detail?type=${name}`} style={{ minWidth: '50px'}}>已授权 查看</a> : <a style={{ minWidth: '50px'}} href={OauthLinkMap[name]}>授权</a>
            }
        </Flex>
    )
}

export default () => {
    const [list, setList] = React.useState([]);
    const getChannleOauthList = async () => {
        const res = await fetch('/api/channel/oauth/list');
        return res.json();
    }
    React.useEffect(() => {
        getChannleOauthList().then((res) => {
            setList(res.data);
        })
    }, []);
    return (
        <Flex justify="flex-start" gap={16} wrap="wrap" style={{ height: '100%' }}>
            <ChannelCard name='wxopen_mini' list={list} icon={<WechatOutlined style={{verticalAlign: 'top'}} />} title="微信小程序" description='将微信小程序与店铺绑定，深度开展品牌宣传和商品交易' />
            <ChannelCard name='wxopen_service' list={list} icon={<WechatOutlined style={{verticalAlign: 'top'}} />} title="微信服务号" description='绑定微信服务号，给客户提供深度消息服务' />
            {/* <ChannelCard name='alipay' list={list} icon={<AlipayOutlined style={{verticalAlign: 'top'}} />} title="支付宝小程序" description='连接支付宝亿级用户，打通线上线下渠道，共享商家生意增长新机会' />
            <ChannelCard name='douyin' list={list} icon={<TikTokOutlined style={{verticalAlign: 'top'}} />} title="抖音小程序" description='打通抖音本地生活，帮助商家快速获客，提高团购券核销，高效沉淀抖音粉丝。' /> */}
        </Flex>
    )
}